import {Component, inject, OnInit, Signal} from '@angular/core';
import {DbStore} from '../../../core/db/models/db-store.model';
import {StoreDbService} from '../../../core/db/store.db.service';
import {Button } from 'primeng/button';
import {AuthService} from '../../../core/auth/auth-service';
import {Router} from '@angular/router';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {Tag} from 'primeng/tag';
import {AuthSessionState} from '../../../core/auth/auth-session.state';
import {BackendUser} from '../../../core/interfaces/UserInterface';

@Component({
  selector: 'app-configuracion-temporal-modal',
  imports: [
    Tag,
    Button
  ],
  templateUrl: './configuracion-temporal-modal.html',
  styleUrl: './configuracion-temporal-modal.scss',
  standalone: true,
})
export class ConfiguracionTemporalModal implements OnInit {
  private storeDbService = inject(StoreDbService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private ref = inject(DynamicDialogRef);
  private session = inject(AuthSessionState);
  private user: Signal<BackendUser | null>;
  store: DbStore | undefined;
  errorMensaje = '';
  constructor() {
    this.user = this.session.rawBackend;
  }
  async ngOnInit() {
    this.store = await this.storeDbService.getConfig();
    console.log(this.store);
  }

  revertirConfiguracion(): void {
    console.log('revertirConfiguracion');
    if(this.user()){
      this.auth.logout().subscribe({
        next: () => {
          console.log('Logout exitoso');
          this.ref.close(true);
          // Inhabilitamos la configuracion temporal
          localStorage.setItem('configTemporal', 'false');
          this.router.navigate(['/login'], { replaceUrl: true});
        },
        error: err => {
          console.error('Error en logout', err);
          this.errorMensaje = 'Ocurrió un error inesperado, inténtalo más tarde.';
        }
      });
    } else {
      this.ref.close(true);
      // Inhabilitamos la configuracion temporal
      localStorage.setItem('configTemporal', 'false');
      this.router.navigate(['/login'], { replaceUrl: true});
    }

  }

}
